import React, { useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Sidebar from "../../templates/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router";
import useRequest from "../../../context/useRequest";
import { useAuth } from "../../../context/AuthContext";
import commuteLoader from "../../../assets/images/commute_loader.gif";

const Profile = () => {
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const { userId } = useAuth();
  const { sendRequest } = useRequest();
  const navigate = useNavigate();

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const response = await sendRequest({
        method: "GET",
        url: `/auth/myProfile/${userId}`,
      });
      if (response.status) {
        setUserDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, [userId, sendRequest]);

  // Optional: Refetch when page/tab gets focus (helps if navigating back)
  useEffect(() => {
    const handleFocus = () => {
      fetchUserDetails();
    };
    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  

  function formatCreatedDate(isoDateString) {
    try {
      if (!isoDateString) return "";

      const date = new Date(isoDateString);

      if (isNaN(date.getTime())) {
        console.warn("Invalid date string:", isoDateString);
        return "";
      }

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Date formatting error:", error);
      return "";
    }
  }

  const handleEditProfile = () => {
    navigate("/update-profile", {
      state: {
        profileDetails: userDetails,
      },
    });
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Image src={commuteLoader} alt="loader" />
      </div>
    );
  }

  return (
    <section className="profile section-padding">
      <Container>
        <Row>
          <Col className="col-12 col-md-3">
            <Sidebar />
          </Col>
          <Col className="col-12 col-md-9">
            <div className="profile--detail">
              <div className="profile--detail-tabs">
                <div className="profile--detail-tabs-title personal-details-container">
                  <div>
                    <h2 className="h3">Profile</h2>
                    <p className="mb-0">Your Europcar account details</p>
                  </div>
                  <button onClick={handleEditProfile} className="btn-custom">
                    Edit Profile
                  </button>
                </div>
              </div>
              <div className="profile--detail-account">
                <div className="profile--detail-account-inforamation">
                  <ul className="profile--detail-account-inforamation-list">
                    <li className="profile--detail-account-inforamation-list-user">
                      <p className="profile--detail-account-inforamation-list-user-left mb-0">
                        First Name
                      </p>
                      <p className="profile--detail-account-inforamation-list-user-right mb-0">
                        {userDetails.first_name}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="profile--detail-account-inforamation">
                  <ul className="profile--detail-account-inforamation-list">
                    <li className="profile--detail-account-inforamation-list-user">
                      <p className="profile--detail-account-inforamation-list-user-left mb-0">
                        Last Name
                      </p>
                      <p className="profile--detail-account-inforamation-list-user-right mb-0">
                        {userDetails.last_name}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="profile--detail-account-inforamation">
                  <ul className="profile--detail-account-inforamation-list">
                    <li className="profile--detail-account-inforamation-list-user">
                      <p className="profile--detail-account-inforamation-list-user-left mb-0">
                        Email
                      </p>
                      <p className="profile--detail-account-inforamation-list-user-right mb-0">
                        {userDetails.email}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="profile--detail-account-inforamation">
                  <ul className="profile--detail-account-inforamation-list">
                    <li className="profile--detail-account-inforamation-list-user">
                      <p className="profile--detail-account-inforamation-list-user-left mb-0">
                        Password
                      </p>
                      <p className="profile--detail-account-inforamation-list-user-right mb-0">
                        ********
                      </p>
                    </li>
                  </ul>
                  <Link
                    className="profile--detail-account-inforamation-link"
                    to="/change-password"
                  >
                    Change
                  </Link>
                </div>
                <div className="profile--detail-account-inforamation">
                  <ul className="profile--detail-account-inforamation-list">
                    <li className="profile--detail-account-inforamation-list-user">
                      <p className="profile--detail-account-inforamation-list-user-left mb-0">
                        Phone number
                      </p>
                      <p className="profile--detail-account-inforamation-list-user-right mb-0">
                        +{userDetails.country_code} {userDetails.phone}
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="profile--detail-account-inforamation">
                  <ul className="profile--detail-account-inforamation-list">
                    <li className="profile--detail-account-inforamation-list-user">
                      <p className="profile--detail-account-inforamation-list-user-left mb-0">
                        Created At
                      </p>
                      <p className="profile--detail-account-inforamation-list-user-right mb-0">
                        {formatCreatedDate(userDetails.created_at)}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Profile;
